var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "p-10" },
    [
      _c("div", { staticClass: "flex justify-between" }, [
        _c("h1", [_vm._v(_vm._s(_vm.$t("recipients")))]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "ml-auto" },
          [
            _vm.recipientsOverviewRightPanelCollapsed
              ? [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.toggleRightPanel(false)
                        }
                      }
                    },
                    [
                      _c("div", [
                        _c("div", { staticStyle: { float: "right" } }, [
                          _c(
                            "svg",
                            {
                              staticClass: "hamburger",
                              staticStyle: { transform: "rotate(180deg)" },
                              attrs: {
                                viewBox: "0 0 1024 1024",
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "17",
                                height: "17"
                              }
                            },
                            [
                              _c("path", {
                                staticStyle: {
                                  fill: "white",
                                  "verical-align": "middle !important"
                                },
                                attrs: {
                                  d:
                                    "M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM142.4 642.1L298.7 519a8.84 8.84 0 0 0 0-13.9L142.4 381.9c-5.8-4.6-14.4-.5-14.4 6.9v246.3a8.9 8.9 0 0 0 14.4 7z"
                                }
                              })
                            ]
                          )
                        ])
                      ])
                    ]
                  )
                ]
              : [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.toggleRightPanel(true)
                        }
                      }
                    },
                    [
                      _c("div", [
                        _c("div", { staticStyle: { float: "right" } }, [
                          _c(
                            "svg",
                            {
                              staticClass: "hamburger",
                              attrs: {
                                viewBox: "0 0 1024 1024",
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "17",
                                height: "17"
                              }
                            },
                            [
                              _c("path", {
                                staticStyle: {
                                  fill: "white",
                                  "verical-align": "middle !important"
                                },
                                attrs: {
                                  d:
                                    "M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM142.4 642.1L298.7 519a8.84 8.84 0 0 0 0-13.9L142.4 381.9c-5.8-4.6-14.4-.5-14.4 6.9v246.3a8.9 8.9 0 0 0 14.4 7z"
                                }
                              })
                            ]
                          )
                        ])
                      ])
                    ]
                  )
                ]
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 5 } },
        [
          _c(
            "el-col",
            { attrs: { span: _vm.rightPanelLayoutVariables.mainPanelWidth } },
            [
              _c(
                "el-card",
                [
                  _c(
                    "div",
                    { staticClass: "filters" },
                    [
                      _c(
                        "el-form",
                        {
                          attrs: { inline: "" },
                          nativeOn: {
                            submit: function($event) {
                              $event.preventDefault()
                            }
                          }
                        },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    disabled: _vm.loading,
                                    value: _vm.filterTags,
                                    "collapse-tags": "",
                                    multiple: "",
                                    size: "mini",
                                    placeholder: _vm.$t("tagFilter")
                                  },
                                  on: { change: _vm.handleTagsFilterChange }
                                },
                                _vm._l(_vm.sortedTags, function(tag, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: _vm.$translate.tag(tag.tag),
                                      value: tag.tag
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    disabled: _vm.loading,
                                    type: "primary",
                                    size: "mini"
                                  },
                                  on: { click: _vm.handleFilter }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t" +
                                      _vm._s(_vm.$t("applyFilters")) +
                                      "\n\t\t\t\t\t\t\t"
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form",
                        {
                          attrs: { inline: "" },
                          nativeOn: {
                            submit: function($event) {
                              $event.preventDefault()
                            }
                          }
                        },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-input",
                                {
                                  attrs: {
                                    disabled: _vm.loading,
                                    size: "mini",
                                    placeholder: ""
                                  },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      )
                                        return null
                                      return _vm.onSearch.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.searchTerm,
                                    callback: function($$v) {
                                      _vm.searchTerm = $$v
                                    },
                                    expression: "searchTerm"
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "el-input__icon el-icon-search",
                                    attrs: { slot: "prefix" },
                                    slot: "prefix"
                                  })
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-checkbox",
                                {
                                  model: {
                                    value: _vm.includeContactsInSearch,
                                    callback: function($$v) {
                                      _vm.includeContactsInSearch = $$v
                                    },
                                    expression: "includeContactsInSearch"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.$t("searchInContactsAndDetails")
                                      ) +
                                      "\n\t\t\t\t\t\t\t"
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    disabled: _vm.loading,
                                    type: "primary",
                                    size: "mini"
                                  },
                                  on: { click: _vm.onSearch }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t" +
                                      _vm._s(_vm.$t("search")) +
                                      "\n\t\t\t\t\t\t\t"
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.userInterfaceDetails &&
                  _vm.userInterfaceDetails?.custom_field_definitions &&
                  _vm.userInterfaceDetails?.custom_field_definitions?.filter(
                    field => field.searchable
                  ).length > 0
                    ? _c(
                        "el-collapse",
                        {
                          model: {
                            value: _vm.customFieldsFiltersVisible,
                            callback: function($$v) {
                              _vm.customFieldsFiltersVisible = $$v
                            },
                            expression: "customFieldsFiltersVisible"
                          }
                        },
                        [
                          _c(
                            "el-collapse-item",
                            {
                              attrs: {
                                title: _vm.$t("custom_fields_filters"),
                                name: "1"
                              }
                            },
                            [
                              _c("custom-fields-filters", {
                                attrs: {
                                  "custom-field-definitions": _vm.userInterfaceDetails?.custom_field_definitions?.filter(
                                    field => field.searchable
                                  ),
                                  change: _vm.handleCustomFiltersChange
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.loading,
                              expression: "loading"
                            }
                          ],
                          ref: "multipleTable",
                          staticStyle: { width: "100%" },
                          attrs: {
                            "highlight-current-row": "",
                            data: _vm.recipients
                          },
                          on: {
                            "row-click": _vm.handleRowClick,
                            "sort-change": _vm.onSortChange
                          }
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("name"),
                              "show-overflow-tooltip": "",
                              sortable: "custom",
                              width: "240",
                              prop: "name"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "router-link",
                                      {
                                        staticClass: "hover-underline fc-blue",
                                        attrs: {
                                          to: {
                                            name: "recipient-detail",
                                            params: {
                                              id: scope.row.reference,
                                              participant:
                                                _vm.selectedParticipantStore
                                            }
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(scope.row.name) +
                                            "\n\t\t\t\t\t\t\t\t"
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$tc("legalEntity"),
                              prop:
                                "legal_entity_by_reference.registration_name",
                              "show-overflow-tooltip": "",
                              width: "192"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          scope.row.legal_entity_by_reference &&
                                            scope.row.legal_entity_by_reference
                                              .registration_name
                                            ? scope.row
                                                .legal_entity_by_reference
                                                .registration_name
                                            : ""
                                        ) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("accountId"),
                              "show-overflow-tooltip": "",
                              prop: "account_id",
                              width: "192"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(scope.row.account_id) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("totalAmount"),
                              "show-overflow-tooltip": "",
                              prop: "total_amount",
                              align: "right",
                              width: "128"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.$formatter.toCurrency(
                                            scope.row.total_amount?.aggregate
                                              ?.sum?.total_amount,
                                            scope.row.currencies?.[0]
                                              ?.amount_currency
                                          )
                                        ) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("open"),
                              "show-overflow-tooltip": "",
                              prop: "open_amount",
                              align: "right",
                              width: "128"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.$formatter.toCurrency(
                                            scope.row.open_amount?.aggregate
                                              ?.sum?.open_amount,
                                            scope.row.currencies?.[0]
                                              ?.amount_currency
                                          )
                                        ) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("dueAmount"),
                              "show-overflow-tooltip": "",
                              prop: "due_amount",
                              align: "right",
                              width: "128"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$formatter.toCurrency(
                                          scope.row.amount_due?.aggregate?.sum
                                            ?.open_amount,
                                          scope.row.currencies?.[0]
                                            ?.amount_currency
                                        )
                                      )
                                    )
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _vm.userInterfaceDetails?.custom_field_definitions &&
                          _vm.userInterfaceDetails?.custom_field_definitions
                            ?.length > 0
                            ? _vm._l(
                                _vm.userInterfaceDetails?.custom_field_definitions?.slice(
                                  0,
                                  5
                                ),
                                function(custom_field_definition) {
                                  return _c(
                                    "el-table-column",
                                    {
                                      key: custom_field_definition.path,
                                      attrs: {
                                        "show-overflow-tooltip": "",
                                        width: "160"
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function(scope) {
                                              return [
                                                scope.row.custom_fields
                                                  ? _c("custom-field-value", {
                                                      attrs: {
                                                        "custom-field-definition": custom_field_definition,
                                                        "custom-fields":
                                                          scope.row
                                                            .custom_fields
                                                      }
                                                    })
                                                  : _vm._e()
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    },
                                    [
                                      _c(
                                        "template",
                                        { slot: "header" },
                                        [
                                          _c("custom-field-label", {
                                            attrs: {
                                              "custom-field-definition": custom_field_definition
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    2
                                  )
                                }
                              )
                            : _vm._e()
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.total != -1
                    ? _c(
                        "div",
                        [
                          _c("pagination", {
                            attrs: {
                              total: _vm.total,
                              page: _vm.page,
                              limit: _vm.limit,
                              disabled: _vm.loading
                            },
                            on: {
                              "update:page": function($event) {
                                _vm.page = $event
                              },
                              "update:limit": function($event) {
                                _vm.limit = $event
                              },
                              pagination: _vm.getList
                            }
                          })
                        ],
                        1
                      )
                    : _c("div", {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: true,
                            expression: "true"
                          }
                        ],
                        staticStyle: {
                          "min-height": "20px",
                          "margin-top": "17px",
                          "font-size": "17px",
                          float: "left"
                        },
                        attrs: {
                          "element-loading-spinner": "el-icon-loading",
                          "element-loading-background": "rgba(0, 0, 0, 0)"
                        }
                      })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: _vm.rightPanelLayoutVariables.rightPanelWidth } },
            [
              _vm.quickViewSelection !== null
                ? _c(
                    "div",
                    [
                      _c("el-card", { staticClass: "box-card" }, [
                        _c(
                          "div",
                          {
                            staticClass: "clearfix disp-flex",
                            attrs: { slot: "header" },
                            slot: "header"
                          },
                          [
                            _c("div", { staticClass: "w-50" }, [
                              _c("h4", { staticClass: "mt-5" }, [
                                _vm._v(_vm._s(_vm.quickViewSelection.name))
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "w-50 text-right" },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "primary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.onViewDetail(
                                          _vm.quickViewSelection,
                                          $event
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(_vm.$t("viewDetail")) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "disp-flex" }, [
                          _c("div", { staticStyle: { "min-width": "180px" } }, [
                            _vm.quickViewSelection.type === "B2B"
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "dark",
                                          content: _vm.$translate.legal_id_type_description(
                                            _vm.quickViewSelection.legal_id_type
                                          )
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "text-color--dark-gray"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate.legal_id_type(
                                                  _vm.quickViewSelection
                                                    .legal_id_type
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", [
                              _c(
                                "span",
                                { staticClass: "text-color--dark-gray" },
                                [_vm._v(_vm._s(_vm.$t("customerNumber")))]
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _vm.quickViewSelection.type === "B2B"
                              ? _c("div", [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.quickViewSelection.legal_id
                                          ? _vm.quickViewSelection.legal_id
                                          : "/"
                                      ) +
                                      "\n\t\t\t\t\t\t\t"
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.quickViewSelection.account_id
                                    ? _vm.quickViewSelection.account_id
                                    : "/"
                                )
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "mt-20" },
                          [
                            _c("contacts", {
                              attrs: {
                                recipient: _vm.quickViewSelection.reference
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "transparentDashboardCard" }, [
                          _c(
                            "div",
                            { staticClass: "mb-20 fs-17 fw-b text-center" },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t" +
                                  _vm._s(_vm.$t("avgPaymentDuration")) +
                                  " (N/A)\n\t\t\t\t\t\t"
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "text-center" },
                            [_c("avg-payment")],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "transparentDashboardCard" },
                          [
                            _c("risk-score", {
                              attrs: {
                                score: _vm.quickViewSelection.prediction_stars
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                : _c(
                    "div",
                    [
                      _c("el-card", [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(
                              _vm.$t("quickViewNotice", {
                                value: _vm.$t("aRecipient")
                              })
                            ) +
                            "\n\t\t\t\t"
                        )
                      ])
                    ],
                    1
                  )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }